export const GET_MRSECTION_DETAILS  = 'GET_MRSECTION_DETAILS';
export const MRSECTION_DETLS_LOADER = 'MRSECTION_DETLS_LOADER';
export const ATTACH_UPLOAD_FILE='ATTACH_UPLOAD_FILE';
export const UPDATE_TE006_FORM='UPDATE_TE006_FORM';
export const MR_DELETE='MR_DELETE';
export const ADD_TE006_SECTION='ADD_TE006_SECTION';
export const MR_SECTION_DELETE='MR_SECTION_DELETE';
export const CLEAR_ERR_MESSGAE_06='CLEAR_ERR_MESSGAE_06';
export const ERROR_MESSAGE_06='ERROR_MESSAGE_06';
